import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Typography } from "@atoms";
import likeIcon from "@assets/icons/love.svg";
import storiesIcon from "@assets/icons/stories.svg"
import repostIcon from "@assets/icons/repost2.svg"

import { Container, Item, IconMask } from "./mobileNav.styles";


function MobileNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");

  const removeTabParam = () => {
    const searchParams = new URLSearchParams(location.search);

    if (!searchParams.has("tab")) return;

    searchParams.delete("tab");

    if (location.pathname.includes("/stories") || location.pathname.includes("/my-stories")) {
      navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
    }
  };

  useEffect(() => {
    if(tab === null) navigate("?tab=my-stories")
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab])

  useEffect(() => {
    return () => {
      removeTabParam();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Container>
      <Item isActive={tab === "tributes"} onClick={() => navigate('?tab=tributes')}>
        <IconMask icon={likeIcon} />
        <Typography as="label">{t("tributes")}</Typography>
      </Item>

      <Item isActive={tab === "my-stories"} onClick={() => navigate('?tab=my-stories')}>
        <IconMask icon={storiesIcon} />
        <Typography as="label">{t(location.pathname.includes("/my-stories") ? "myStories" : "myStories")}</Typography>
      </Item>

      <Item isActive={tab === "repost"} onClick={() => navigate('?tab=repost')}>
        <IconMask icon={repostIcon} />
        <Typography as="label">{t("share")}</Typography>
      </Item>
    </Container>
  );
}

export default MobileNav;
